/* global mixpanel */
import React from 'react'
import {
    NoTags,
    CompoundTags,
} from './tag'
import { shortStartStopTime } from '../util/fmt_utils'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import {
    groupTagsByTeam,
} from '../common/components/time_row'
import { confirmHighDuration, msToHrsRounded } from '../util/time_utils'
import { sanitizeEntries } from '../util/random_utils.js'
import GA from "react-ga"

class TimeRow extends React.Component {
    constructor(props) {
        super(props)

        this.renderPlay = this.renderPlay.bind(this)
        this.renderStop = this.renderStop.bind(this)
        this.renderDetail = this.renderDetail.bind(this)
        this.editTimeEntry = this.editTimeEntry.bind(this)
        this.play = this.play.bind(this)
        this.stop = this.stop.bind(this)
    }

    play(entry) {
        // start a new entry
        // TODO: Multiteam
        const timeEntryMeta = {
            userId: entry.userId,
            teamId: entry.teamId,
            startAt: Date.now(),
            endAt: null,
            tags: entry.tags,
            description: entry.description,
        }
        // TODO: Multiteam
        const { userId: creatorId, teamId, tags=[] } = timeEntryMeta
        mixpanel.track("Start timer - time entry row", { teamId, creatorId, tagCount: tags.length })
        GA.event({category: "User", action: "Start timer - time entry row"})

        this.props.createTimeEntry(timeEntryMeta)
    }

    stop(runningEntries) {
        const entries = sanitizeEntries(this.props.timeEntries)
        runningEntries.map(entryId => {
            let entry = entries[entryId]
            if (entry === undefined) {
                return
            }
            // TODO: Multiteam
            const timeEntryMeta = {
                id: entry.id,
                userId: entry.userId,
                teamId: entry.teamId,
                startAt: entry.startAt,
                endAt: Date.now(),
                tags: entry.tags,
                description: entry.description,
            }

            if (!confirmHighDuration(timeEntryMeta)) {
                this.props.openTimeEntryModal(timeEntryMeta)
                return
            }

            this.props.updateTimeEntry(timeEntryMeta)
            // TODO: Multiteam
            const { userId: creatorId, teamId, tags=[] } = timeEntryMeta
            mixpanel.track("Stop timer - time entry row", { teamId, creatorId, tagCount: tags.length })
            GA.event({category: "User", action: "Stop timer - time entry row"})
        })
    }

    renderPlay(entry) {
        if (!entry) return
        return (
            <div className="btn btn-play" onClick={
                (e) => {
                    e.stopPropagation()
                    this.play(entry)
                }}>
                <i className="fa fa-play" aria-hidden="true"></i>
            </div>
        )
    }

    renderStop(runningEntries) {
        return (
            <div className="btn btn-stop" onClick={
                (e) => {
                    e.stopPropagation()
                    this.stop(runningEntries)
                }}>
                <i className="fa fa-stop" aria-hidden="true"></i>
            </div>
        )
    }

    editTimeEntry(latestTimeEntry) {
        if (latestTimeEntry) {
            this.props.editTimeEntry(latestTimeEntry.id)
        }
    }

    renderTags(tags) {
        if (tags.length === 0) {
            return <NoTags />
        }
        // group tags by team
        const tagsByTeam = groupTagsByTeam(tags, this.props.tags)
        // TODO: Multiteam
        const teamIds = Object.keys(tagsByTeam)
        const teams = teamIds.reduce((acc, teamId) => {
            const team = this.props.teams.find(t => t.id === teamId)
            return team ? [...acc, team] : acc
        }, [])

        const personalTeams = teams.filter(team => team.isPersonal)
        const sharedTeams = teams.filter(team => !team.isPersonal)
        const sortedTeams = [...sharedTeams, ...personalTeams]

        return sortedTeams.map(team => {
            return CompoundTags(team, tagsByTeam[team.id])
        })
    }

    renderDetail() {
        const { timeEntries, isCollapsed, userId } = this.props
        const { descriptions, total, tags, runningEntries, latestEntryId, id } = this.props.item
        const latestTimeEntry = timeEntries[latestEntryId]
        const rowClickHandler = !isCollapsed ? this.editTimeEntry.bind(this, latestTimeEntry) : () => { }
        const isSameUser = userId === sanitizeEntries(this.props.timeEntries)[id].userId
        const totalHours = msToHrsRounded(total)

        return (
            <div className="time-entry-detail" onClick={rowClickHandler}>
                <div className={`time-entry-tags ${isCollapsed && "collapsed"}`}>
                    {this.renderTags(tags)}
                </div>
                {!isCollapsed && latestTimeEntry && <div className="time-entry-start-stop">{shortStartStopTime(latestTimeEntry.startAt, latestTimeEntry.endAt)}</div>}
                <div className="time-entry-hours">{totalHours}</div>

                {!isCollapsed && isSameUser && runningEntries && runningEntries.length > 0
                    ? this.renderStop(runningEntries)
                    : this.renderPlay(latestTimeEntry)
                }
                <span className="time-entry-desc">
                    {!isCollapsed && latestTimeEntry && latestTimeEntry.description}
                </span>
                {isCollapsed && descriptions[0] !== undefined && <div className="time-entry-desc collapsed">
                    {descriptions.map((d, i) => <p key={`${d}-${i}`}>{d}</p>)}
                </div>}
            </div>
        )
    }

    render() {
        // when displaying collapsed rollups or on low res mobile devices, render without "Edit Entry" tool tip
        if (!this.props.showEditTooltips) {
            return this.renderDetail()
        }

        // when displaying individual entries on high res screens, render "Edit Entry" tool tip
        return (
            <OverlayTrigger placement="bottom" delayShow={300} delayHide={150} overlay={<Tooltip id="tip-edit-entry">Edit entry</Tooltip>}>
                {this.renderDetail()}
            </OverlayTrigger>
        )
    }
}

export default TimeRow



// WEBPACK FOOTER //
// ./src/components/time_row.jsx